export default __webpack_public_path__ + "static/media/bg_splash.738659bd.webp";